import { Component } from '@angular/core';

@Component({
    selector: 'app-summery-registration-form',
    templateUrl: './summery-registration-form.component.html'
})
export class SummeryRegistrationFormComponent {}
